<template>
  <div class="app-container">
    <div class="searchArea">
      <div style="display: flex; align-items: center;">
        <a-input v-model:value="searchParams.name" placeholder="请输入活动名称" style="width: 200px; margin-right: 16px;" allowClear @pressEnter="handleSearch" />
        <a-button type="primary" shape="circle" @click="handleSearch">
          <template #icon>
            <SearchOutlined /></template>
        </a-button>
        <a-button style="margin-left: 8px;" @click="resetSearch">重置</a-button>
        <a-button style="margin-left: 15px;" type="primary" @click="handleAdd">
          <plus-outlined /> 新增活动
        </a-button>
      </div>
    </div>
    <a-table rowKey="id" :columns="columns" :data-source="tableData" :loading="loading" :pagination="false" class="ant-table-striped">
      <template #imgSlot="{ record }">
        <img v-if="record.imageUuid" :src="imageUrl + record.imageUuid" style="width: 80px; height: 40px; object-fit: cover; border-radius: 4px;" />
        <span v-else>-</span>
      </template>
      <template #operation="{ record }">
        <a-button type="link" size="small" @click="handleEdit(record)">编辑</a-button>
        <a-divider type="vertical" />
        <a-popconfirm title="确定要删除此活动吗？" @confirm="handleDelete(record)">
          <a-button type="link" size="small" danger>删除</a-button>
        </a-popconfirm>
      </template>
    </a-table>

    <activity-modal v-model:visible="modalVisible" :record="currentRecord" @ok="handleSuccess" />
  </div>
</template>

<script>
import { PlusOutlined, SearchOutlined } from '@ant-design/icons-vue';
// 修改引入路径和方法名
import { GetActivityList, DeleteActivity } from "@/api/shopping";
import ActivityModal from "@/components/shopping/activityModal.vue";

export default {
  name: "ShoppingActivity",
  components: {
    PlusOutlined,
    ActivityModal,
    SearchOutlined
  },
  data() {
    return {
      loading: false,
      imageUrl: '/api/file/img/',
      searchParams: {
        name: ''
      },
      tableData: [],
      modalVisible: false,
      currentRecord: {},
      columns: [
        {
          title: '活动名称',
          dataIndex: 'name',
          key: 'name',
          align: 'center'
        },
        {
          title: '活动图片',
          key: 'imageUuid',
          slots: { customRender: 'imgSlot' },
          align: 'center'
        },
        {
          title: '页面路径',
          dataIndex: 'value',
          key: 'value',
          align: 'center',
          customRender: ({ text }) => text || '-'
        },
        {
          title: '操作',
          key: 'action',
          slots: { customRender: 'operation' },
          align: 'center',
          width: 200
        }
      ]
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      
      this.loading = true;
      try {
        // 使用新的接口名称
        const res = await GetActivityList();
        if (res.errCode === 0) {
          this.tableData = res.data || [];
        }
      } catch (error) {
        console.error('Fetch error:', error);
        this.$message.error('获取列表失败');
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.fetchData();
    },
    resetSearch() {
      this.searchParams.name = '';
      this.fetchData();
    },
    handleAdd() {
      this.currentRecord = {};
      this.modalVisible = true;
    },
    handleEdit(record) {
      this.currentRecord = { ...record };
      this.modalVisible = true;
    },
    async handleDelete(record) {
      try {
        // 使用新的接口名称
        const res = await DeleteActivity({ id: record.id });
        if (res.errCode === 0) {
          this.$message.success('删除成功');
          this.fetchData();
        } else {
          this.$message.error(res.errMsg || '删除失败');
        }
      } catch (error) {
        this.$message.error('操作异常');
      }
    },
    handleSuccess() {
      this.fetchData();
    }
  }
};
</script>

<style scoped>
</style>